import SystemResultsSummaryDivider from "../../../dividers/SystemResultsSummaryDivider";
import SystemResultsCardHeaderDivider from "../../../dividers/SystemResultsCardHeaderDivider";
import FlashResultsScore from "../../../others/courses/flash/FlashResultsScore";
import FlashResultsCardHeader from "../../../others/courses/flash/FlashResultsCardHeader";
import FlashResultsDetailedScores from "../../../others/courses/flash/FlashResultsDetailedScores";
import FlashResultsScoreCardContentLayout from "../../../layouts/courses/flash/FlashResultsScoreCardContentLayout";

export default function FlashResultsDesktopScoreCard({scores, total}) {
    // Used in FlashResultsScreen to display flash score summary

    // BUILD
    return (
        <div className={"hidden h-[240px] min-h-[240px] w-[400px] min-w-[400px] sm:flex sm:flex-col bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px]"}>
            <FlashResultsCardHeader headerTitle={"Résultats"} />
            <SystemResultsCardHeaderDivider />
            <FlashResultsScoreCardContentLayout>
                <FlashResultsScore correctAnswers={scores[0]}
                                   total={total}/>
                <SystemResultsSummaryDivider />
                <FlashResultsDetailedScores good={scores[0]}
                                            bad={scores[1]}
                                            neutral={scores[2]} />
            </FlashResultsScoreCardContentLayout>
        </div>
    );
}